import { ComponentChildren } from "preact"
import styles from "./Heading.module.css"
import { cl } from "@nosto/search-js/utils"

type HeadingLevel = "h1" | "h2" | "h3" | "h4" | "h5" | "h6"

type HeadingProps = {
  as?: HeadingLevel
  className?: string
  children: ComponentChildren
}

export default function Heading({ as = "h3", className, children }: HeadingProps) {
  const Tag = as
  return <Tag className={cl(styles.heading, className)}>{children}</Tag>
}
